import { IAppointment, IBusinessBaseInfo, ICustomerBase, IGuest } from ".";

export interface INotification {
    id: number,
    status: NotificationStatus,
    content: string,
    created: Date,
    businessProfile:IBusinessBaseInfo,
    customerProfile: ICustomerBase,
    possibleActions: INotificationAction[]
    appointment : IAppointment,
    userType : ForUserType,
    guest: IGuest;
  }
  
export interface INotificationAction
{
    method:string,
    url:string,
    actionName:string
}


  export enum NotificationStatus {
    New = "New",
    Read= "Read",
    Expired = "Expired"
  }

  export enum ForUserType  {
    Business= "Business",
    Customer ="Customer",
    All = "All"
  }